import { api } from "../client";

export async function lenderSignIn({ email, password }) {
  const payload = {
    usr: email,
    pwd: password,
    email,
    password,
  };
  const res = await api.post("/api/method/dynesourcerapi.author.login", payload);
  return {
    data: res.data,
    headers: res.headers,
  };
}
